<template lang='pug'>
v-select(
  v-bind='$attrs'
  v-bind.props='$props'
  @input='$emit("input", $event)'
  @change='$emit("change", $event)'
  :items='list'
  item-value='id'
  item-text='region_name'
)
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import picker from '@/mixins/picker'

export default {
  mixins: [picker],

  props: {
    label: {
      default: 'Регион'
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },

  created() {
    this.fetch()
  },

  methods: mapActions('dictionary/regionsvacancy', ['fetch']),
  computed: mapGetters('dictionary/regionsvacancy', ['list'])
}
</script>
